import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { gadsdenALConfig } from "./data";

export default function GadsdenALPage() {
  return <CityPageTemplate config={gadsdenALConfig} />;
}